import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    reservation: null,
};

export const meetingRoomPriceSlice = createSlice({
    name: "meetingRoomPrice",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        pricesFetched: (state, action) => {
            state.loading = false;
            state.error = null;
            state.reservation = action.payload
        },
    }
});
